import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import SpeedIcon from "@material-ui/icons/Speed";
import * as Glob from "../../Globale";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _BondsRatesForm, _InfoSection } from "../components";

export interface IRouteParam {
    ID_Binder: string;
}

export const _BondsRates: React.FC<Glob.IRouteGlobaleProps> = props => {
    const ID_Binder = useParams<IRouteParam>().ID_Binder;

    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideTassiController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={SpeedIcon} Title="Tassi" />
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoSection DataUrl={`/api/binder/Contesto?ID_Binder=${ID_Binder}`} LinkUrl={`/binder/${ID_Binder}`} Title="Binder" />
                        </Grid>
                        <Grid item xs={12}>
                            <_BondsRatesForm ID_Binder={ID_Binder} />
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BondsRates.tsx